import { useCallback, useEffect, useState } from 'react';
import {
  listAdminOffers, createAdminOffer, updateAdminOffer, deleteAdminOffer,
  type AdminOfferRow, type CreateOfferInput, type UpdateOfferInput,
} from '../api/admin';

export const useAdminOffers = (productCode: string) => {
  const [offers, setOffers] = useState<AdminOfferRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [mutating, setMutating] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listAdminOffers(productCode);
      setOffers(res.data.data.items);
    } finally {
      setLoading(false);
    }
  }, [productCode]);

  useEffect(() => { refresh(); }, [refresh]);

  const createOffer = useCallback(async (input: CreateOfferInput) => {
    setMutating(true);
    try {
      const res = await createAdminOffer(input);
      await refresh();
      return res.data.data;
    } finally {
      setMutating(false);
    }
  }, [refresh]);

  const updateOffer = useCallback(async (offerId: number, input: UpdateOfferInput) => {
    setMutating(true);
    try {
      const res = await updateAdminOffer(offerId, input);
      await refresh();
      return res.data.data;
    } finally {
      setMutating(false);
    }
  }, [refresh]);

  const removeOffer = useCallback(async (offerId: number) => {
    setMutating(true);
    try {
      await deleteAdminOffer(offerId);
      await refresh();
    } finally {
      setMutating(false);
    }
  }, [refresh]);

  return { offers, loading, mutating, refresh, createOffer, updateOffer, removeOffer };
};
